import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonSizeEnum, ButtonTypesEnum, IconDirectionEnum } from '../../interfaces/button';

@Component({
  selector: 'ui-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() label!: string;
  @Input() buttonType: ButtonTypesEnum = ButtonTypesEnum.PRIMARY;
  @Input() buttonSize: ButtonSizeEnum = ButtonSizeEnum.MEDIUM;
  @Input() iconDirection: IconDirectionEnum = IconDirectionEnum.RIGHT;
  @Input() isDisabled = false;
  @Input() isRounded = false;
  @Output() eventButton: EventEmitter<void> = new EventEmitter();
  iconDirectionEnum = IconDirectionEnum;

  get isPrimaryButton(): boolean {
    return this.buttonType === ButtonTypesEnum.PRIMARY;
  }

  get isOutlineButton(): boolean {
    return this.buttonType === ButtonTypesEnum.OUTLINE;
  }

  get isTextButton(): boolean {
    return this.buttonType === ButtonTypesEnum.TEXT;
  }

  get isMediumButton(): boolean {
    return this.buttonSize === ButtonSizeEnum.MEDIUM;
  }

  get isLargeButton(): boolean {
    return this.buttonSize === ButtonSizeEnum.LARGE;
  }

  handleClick(event: Event) {
    if(this.isDisabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    } else {
      this.eventButton.emit();
    }
  }
}
